import { useDispatch, useSelector } from "react-redux";
import { Toaster, Toast, Intent } from "@blueprintjs/core";
import { setMessage, IToastMessage } from "controllers/common/action";
import { selectMessage } from "controllers/common/action";
import "./Message.scss";

function Message() {
  const raw = useSelector(selectMessage);
  const dispatch = useDispatch();

  const text = typeof raw === "string" ? raw : (raw as IToastMessage | undefined)?.text;
  if (!text) {
    return null;
  }

  const intent = typeof raw === "object" ? (raw as IToastMessage).intent : undefined;
  const timeout = typeof raw === "object" ? (raw as IToastMessage).timeout : undefined;

  const iconOverride = typeof raw === "object" ? (raw as IToastMessage).icon : undefined;
  const iconByIntent = (i?: Intent) => {
    switch (i) {
      case Intent.SUCCESS:
        return "tick-circle";
      case Intent.DANGER:
        return "error";
      case Intent.WARNING:
        return "warning-sign";
      case Intent.PRIMARY:
      default:
        return "info-sign";
    }
  };
  const icon = iconOverride || iconByIntent(intent);

  return (
    <Toaster className="message" position="bottom">
      {
        raw &&
        <Toast icon={icon} intent={intent} message={text} onDismiss={() => dispatch(setMessage(""))} timeout={timeout} />
      }
    </Toaster>
  );
}

export default Message;
